import React from 'react';
import { FileTextIcon, CameraIcon, CreditCardIcon, ClipboardListIcon, AlertTriangleIcon, ArrowRightIcon, LayoutDashboardIcon, FileStackIcon, ClipboardCheckIcon, FolderIcon, BarChart3Icon, LeafIcon, CheckIcon, XIcon, ClockIcon, UserIcon, SparklesIcon } from 'lucide-react';
import { readyPhone, caseDashboard, type Bi } from '../../../data/permisSolution';
import { GreenCheck } from '../PermisCards';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
const ITEM_ICONS = {
  form: ClipboardListIcon,
  file: FileTextIcon,
  photo: CameraIcon,
  pay: CreditCardIcon
} as const;
export function ReadyPhone({
  isFR
}: P) {
  const pick = pk(isFR);
  const r = readyPhone;
  return <div className="w-[270px] rounded-[42px] bg-[#16171D] p-[9px] shadow-[0_40px_70px_-30px_rgba(20,20,60,0.6)]" data-id="element-5219" data-mp="tel8fcdzpxwi">
      <div className="relative rounded-[34px] bg-white overflow-hidden" data-id="element-5220" data-mp="ycd1i9qdfq2a">
        <div className="absolute left-1/2 top-2 -translate-x-1/2 w-[86px] h-[24px] rounded-full bg-[#16171D]" aria-hidden="true" data-id="element-5221" data-mp="13e2c5o9om1pu" />
        <div className="flex items-center justify-between px-6 pt-3 font-sans text-[10.5px] font-semibold text-[#121212]" data-id="element-5222" data-mp="1i0hy993d2ok9">
          <span data-id="element-5223" data-mp="191wljukkm3re">9:41</span>
          <span className="flex gap-1" aria-hidden="true" data-id="element-5224" data-mp="1937l1i6zgpcp">
            <span className="w-3.5 h-2 rounded-sm bg-[#121212]" data-id="element-5225" data-mp="143363wlq42ol" />
            <span className="w-5 h-2 rounded-sm bg-[#121212]" data-id="element-5226" data-mp="144xob35m1goz" />
          </span>
        </div>
        <div className="px-3.5 pt-6 pb-3.5" data-id="element-5227" data-mp="20su6gcgp4k2b">
          <p className="font-sans text-[14px] font-semibold text-[#121A3A] leading-snug max-w-[180px]" data-id="element-5228" data-mp="1ws0mtvaadrf8">{pick(r.title)}</p>
          <div className="mt-2.5 flex items-center gap-2" data-id="element-5229" data-mp="1s08vvjn7xjok">
            <span className="flex-1 h-1.5 rounded-full bg-[#ECEBFB] overflow-hidden" data-id="element-5230" data-mp="1rypf7rxnh6m9">
              <span className="block h-full rounded-full bg-[#4F46E5]" style={{
              width: `${r.progress}%`
            }} data-id="element-5231" data-mp="1mzuuulk1ba01" />
            </span>
            <span className="font-sans text-[9.5px] font-semibold text-[#121A3A]" data-id="element-5232" data-mp="2fqwd4vj0xlns">{r.progress}{isFR ? ' %' : '%'}</span>
          </div>
          <ul className="mt-3 rounded-xl border border-[#EEEEF4] divide-y divide-[#F0F0F5]" data-id="element-5233" data-mp="2yo6bdv78yi9o">
            {r.items.map((it, i) => {
            const Icon = ITEM_ICONS[it.kind];
            return <li key={i} className="flex items-center gap-2.5 px-2.5 py-2" data-id="element-5234" data-mp="2ptrvprit15q1" data-mpi={i}>
                  <span className="w-7 h-7 rounded-lg bg-[#E9F6EE] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-5235" data-mp="2tvdajiewfu2v">
                    <Icon className="w-3.5 h-3.5 text-[#22A04F]" strokeWidth={2} data-id="element-5236" data-mp="2fv2em0yqfpau" />
                  </span>
                  <span className="flex-1 min-w-0" data-id="element-5237" data-mp="2kwrpnglyg2yx">
                    <span className="block font-sans text-[10px] font-medium text-[#121A3A]" data-id="element-5238" data-mp="26wh0qj47gyge">{pick(it.name)}</span>
                    {it.meta && <span className="block font-sans text-[8.5px] text-[#8A90A2]" data-id="element-5239" data-mp="2axst2wegrxsa">{pick(it.meta)}</span>}
                  </span>
                  <GreenCheck size={14} data-id="element-5240" data-mp="52hptyuzwj48" />
                </li>;
          })}
            <li className="flex items-start gap-2.5 px-2.5 py-2 bg-[#FFFBEB]" data-id="element-5241" data-mp="93tikd961kgn">
              <AlertTriangleIcon className="w-5 h-5 text-[#D97706] shrink-0 mt-0.5" strokeWidth={1.9} aria-hidden="true" data-id="element-5242" data-mp="1tohto5u1o6lo" />
              <span className="min-w-0" data-id="element-5243" data-mp="1pka64bzbowp1">
                <span className="block font-sans text-[10px] font-semibold text-[#121A3A]" data-id="element-5244" data-mp="23e1ehh1biaj6">{pick(r.warnTitle)}</span>
                <span className="block font-sans text-[8.5px] text-[#5B6478] leading-snug" data-id="element-5245" data-mp="1ym03dyfvypuq">{pick(r.warnBody)}</span>
              </span>
            </li>
          </ul>
          <span className="mt-3 flex items-center justify-center gap-2 rounded-xl bg-[#4F46E5] py-2.5 font-sans text-[11.5px] font-semibold text-white" data-id="element-5246" data-mp="28d4j50ddyeqm">
            {pick(r.cta)}
            <ArrowRightIcon className="w-3.5 h-3.5" strokeWidth={2.2} aria-hidden="true" data-id="element-5247" data-mp="2ma9mgslpszi6" />
          </span>
        </div>
      </div>
    </div>;
}
const NAV = [{
  icon: LayoutDashboardIcon,
  label: {
    fr: 'Tableau de bord',
    en: 'Dashboard'
  }
}, {
  icon: FileStackIcon,
  label: {
    fr: 'Demandes de permis',
    en: 'Permit applications'
  }
}, {
  icon: ClipboardCheckIcon,
  label: {
    fr: 'Inspections',
    en: 'Inspections'
  }
}, {
  icon: CreditCardIcon,
  label: {
    fr: 'Paiements',
    en: 'Payments'
  }
}, {
  icon: FolderIcon,
  label: {
    fr: 'Documents',
    en: 'Documents'
  }
}, {
  icon: BarChart3Icon,
  label: {
    fr: 'Analytique',
    en: 'Analytics'
  }
}];
export function CaseDashboard({
  isFR
}: P) {
  const pick = pk(isFR);
  const d = caseDashboard;
  return <div className="rounded-[26px] bg-[#1B1D24] p-[8px] shadow-[0_40px_80px_-40px_rgba(20,20,60,0.55)]" data-id="element-5248" data-mp="5qyy9p4rqv8y">
      <div className="rounded-[20px] bg-white overflow-hidden flex" data-id="element-5249" data-mp="aqbsww1vt6m3">
        <aside className="hidden sm:block w-[130px] shrink-0 border-r border-[#F0F0F5] bg-[#FAFAFD] px-2.5 py-3.5" data-id="element-5250" data-mp="fon2d5o9lf3s">
          <p className="flex items-center gap-1.5 px-1 font-sans text-[9.5px] font-semibold text-[#121A3A]" data-id="element-5251" data-mp="kfd8il4illzj">
            <span className="w-5 h-5 rounded-md bg-[#22A04F] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-5252" data-mp="3j42cs80k1qpg">
              <LeafIcon className="w-3 h-3 text-white" strokeWidth={2.2} data-id="element-5253" data-mp="3o2c76geggna0" />
            </span>
            <span className="truncate" data-id="element-5254" data-mp="3gk5oov39ur0v">{d.city}</span>
          </p>
          <ul className="mt-4 space-y-1" data-id="element-5255" data-mp="3blb5vt5b12gr">
            {NAV.map((n, i) => {
            const Icon = n.icon;
            const on = i === 1;
            return <li key={i} className={`flex items-center gap-1.5 rounded-md px-1.5 py-1.5 font-sans text-[8.5px] ${on ? 'bg-[#1B1E3A] text-white font-semibold' : 'text-[#5B6478]'}`} data-id="element-5256" data-mp="31neyncfhmrnx" data-mpi={i}>
                  <Icon className="w-3 h-3 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-5257" data-mp="2xnw9g4gmvufa" />
                  <span className="truncate" data-id="element-5258" data-mp="2st082dpibupi">{pick(n.label)}</span>
                </li>;
          })}
          </ul>
        </aside>
        <div className="flex-1 min-w-0 p-3.5" data-id="element-5259" data-mp="2ixfbiv37jmn5">
          <div className="flex items-center justify-between gap-2" data-id="element-5260" data-mp="2iyqeisotwqd7">
            <p className="font-sans text-[13px] font-semibold text-[#121A3A]" data-id="element-5261" data-mp="2dwrcpn8qm1id">{pick(d.title)}</p>
            <span className="flex items-center gap-1 rounded-full bg-[#F1F0FD] px-2.5 py-1 font-sans text-[8.5px] font-semibold text-[#4F46E5] whitespace-nowrap" data-id="element-5262" data-mp="29xa3qju3qm8g">
              <ClockIcon className="w-2.5 h-2.5" aria-hidden="true" data-id="element-5263" data-mp="24a6wfj6s2x5w" />
              {pick(d.status)}
            </span>
          </div>
          <ul className="mt-3 grid grid-cols-4 gap-2" data-id="element-5264" data-mp="1qbgzq4nvezi2">
            {d.checks.map((c, i) => <li key={i} className="rounded-xl border border-[#EEEEF4] px-1.5 py-2.5 flex flex-col items-center text-center" data-id="element-5265" data-mp="1v8qnzgzix54b" data-mpi={i}>
                <GreenCheck size={16} data-id="element-5266" data-mp="2izmhcijmo8do" />
                <span className="mt-1.5 font-sans text-[7.5px] text-[#3A4050] leading-tight" data-id="element-5267" data-mp="2n0oij4x3uuia">{pick(c.label)}</span>
                {c.sub && <span className="font-sans text-[7px] text-[#1E8A45]" data-id="element-5268" data-mp="29a2yvdztugjc">{pick(c.sub)}</span>}
              </li>)}
          </ul>
          <div className="mt-3 flex items-center justify-between border-b border-[#F0F0F5]" data-id="element-5269" data-mp="2e6jpceui16zl">
            <ul className="flex gap-4 overflow-hidden" data-id="element-5270" data-mp="31wdwqgw1u3cg">
              {d.tabs.map((t, i) => <li key={i} className={`font-sans text-[8.5px] pb-1.5 whitespace-nowrap ${i === 0 ? 'text-[#121A3A] font-semibold border-b-2 border-[#4F46E5]' : 'text-[#6B7180]'}`} data-id="element-5271" data-mp="36q8fni3tyeah" data-mpi={i}>
                  {pick(t)}
                </li>)}
            </ul>
            <XIcon className="w-3 h-3 text-[#9A9FB5] shrink-0" aria-hidden="true" data-id="element-5272" data-mp="3ptk1bmgfz3h2" />
          </div>
          <ol className="mt-3 grid grid-cols-5 relative" data-id="element-5273" data-mp="3ktxo3d0m5n89">
            <span className="absolute left-[10%] right-[10%] top-[10px] h-px bg-[#E6E7EF]" aria-hidden="true" data-id="element-5274" data-mp="3kwjuvafojypf" />
            <span className="absolute left-[10%] w-[20%] top-[10px] h-px bg-[#4F46E5]" aria-hidden="true" data-id="element-5275" data-mp="2t31c0emdnmm1" />
            {d.workflow.map((w, i) => <li key={i} className="relative flex flex-col items-center text-center" data-id="element-5276" data-mp="373lsv58qf8cw" data-mpi={i}>
                <span className={`w-5 h-5 rounded-full flex items-center justify-center font-sans text-[8.5px] font-semibold ${w.state === 'done' ? 'bg-[#1B1E3A] text-white' : w.state === 'current' ? 'bg-[#4F46E5] text-white ring-4 ring-[#4F46E5]/15' : 'bg-[#F1F2F6] text-[#5B6478]'}`} data-id="element-5277" data-mp="322odf0f3wsf3">
                  {w.state === 'done' ? <CheckIcon className="w-3 h-3" strokeWidth={3} data-id="element-5278" data-mp="2fusmqzxexrw6" /> : i + 1}
                </span>
                <span className={`mt-1.5 font-sans text-[8px] ${w.state === 'current' ? 'text-[#4F46E5] font-semibold' : 'text-[#121A3A]'}`} data-id="element-5279" data-mp="2ktvni86d1byc">{pick(w.label)}</span>
                <span className={`font-sans text-[7px] ${w.state === 'current' ? 'text-[#4F46E5]' : 'text-[#8A90A2]'}`} data-id="element-5280" data-mp="2pmyhghf1unf2">{pick(w.status)}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </div>;
}
export function OperationalCards({
  isFR
}: P) {
  const pick = pk(isFR);
  const d = caseDashboard;
  const card = 'rounded-2xl border border-[#ECECF4] bg-white shadow-[0_18px_40px_-28px_rgba(40,36,120,0.45)] p-3.5';
  return <div className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_1.5fr] gap-3" data-id="element-5281" data-mp="197x79470ifb5">
      <div className={`${card} flex items-start gap-3`} data-id="element-5282" data-mp="1e5f5o0nelc4w">
        <ClockIcon className="w-6 h-6 text-[#4F46E5] shrink-0" strokeWidth={1.7} aria-hidden="true" data-id="element-5283" data-mp="1e81ee3m15xop" />
        <div data-id="element-5284" data-mp="16oipxhu0pc8q">
          <p className="font-sans text-[10px] text-[#6B7180]" data-id="element-5285" data-mp="11vpkerqq5zvl">{pick(d.sla.label)}</p>
          <p className="font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-5286" data-mp="11tml1h3omue7">{pick(d.sla.value)}</p>
          <p className="font-sans text-[9.5px] text-[#8A90A2] mt-1 leading-snug" data-id="element-5287" data-mp="wujrotx2ecm2">{pick(d.sla.sub)}</p>
        </div>
      </div>
      <div className={`${card} flex items-start gap-3`} data-id="element-5288" data-mp="1pl1oxeb3xjrk">
        <UserIcon className="w-6 h-6 text-[#4F46E5] shrink-0" strokeWidth={1.7} aria-hidden="true" data-id="element-5289" data-mp="1pkijgx2n8nuf" />
        <div data-id="element-5290" data-mp="1kn068uhlfmgm">
          <p className="font-sans text-[10px] text-[#6B7180]" data-id="element-5291" data-mp="1kke111i6dj1k">{pick(d.owner.label)}</p>
          <p className="font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-5292" data-mp="1flaybnpo3owr">{pick(d.owner.value)}</p>
          <p className="font-sans text-[9.5px] font-semibold text-[#3A4050] mt-1" data-id="element-5293" data-mp="1bnlja50mxu0v">{pick(d.owner.nextLabel)}</p>
          <p className="font-sans text-[9.5px] text-[#8A90A2]" data-id="element-5294" data-mp="45m8mol14bs9">{pick(d.owner.next)}</p>
        </div>
      </div>
      <div className={`${card} flex items-start gap-3`} data-id="element-5295" data-mp="i2fd65ggd9l8">
        <SparklesIcon className="w-6 h-6 text-[#4F46E5] shrink-0" strokeWidth={1.7} aria-hidden="true" data-id="element-5296" data-mp="i2ytjhqgfpx5" />
        <div data-id="element-5297" data-mp="e2oqacu1rdlz">
          <p className="font-sans text-[12px] font-semibold text-[#121A3A]" data-id="element-5298" data-mp="dyr5znvqgg0i">{pick(d.reco.title)}</p>
          <p className="font-sans text-[10px] text-[#5B6478] mt-1.5 leading-snug" data-id="element-5299" data-mp="rubnqfzq6s6c">{pick(d.reco.body)}</p>
        </div>
      </div>
    </div>;
}